/**
 * Decode JWT payload (middle segment, base64url). Client-side only — we
 * trust the token because backend signed it, we don't verify the signature
 * here (that's backend's job on every authenticated request).
 *
 * Written inline to avoid the jwt-decode dep: v3 was lenient and worked,
 * v4 has strict base64 length checks that reject some valid Rails-issued
 * tokens (length % 4 === 1 edge case). Keeping it in-tree makes the
 * behavior ours to control and removes one more pentest-flagged lib.
 */
function decodeJwtPayload (token) {
  const parts = token.split('.')
  if (parts.length < 2) throw new Error('Invalid JWT: missing payload segment')
  const base64url = parts[1]
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/')
  // Pad to multiple of 4 with '=' (permissive — never throws on odd length)
  const padded = base64 + '=='.slice(0, (4 - base64.length % 4) % 4)
  const binary = atob(padded)
  // Decode UTF-8 (handles special chars in email, etc.)
  const json = decodeURIComponent(
    binary.split('').map(c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')).join('')
  )
  return JSON.parse(json)
}

export default class Client {
  static from (token) {
    try {
      const obj = decodeJwtPayload(token)
      return new Client(obj)
    } catch (_) {
      return null
    }
  }

  constructor ({ client_id, login, reset_password, locale, registered, accept_terms, terms_variant, terms_version, filled_marketing_consent_date, agreement_with, user_hashed_id, installed_app }) { // eslint-disable-line camelcase
    this.id = client_id // eslint-disable-line camelcase
    this.login = login
    this.reset_password = reset_password // eslint-disable-line camelcase
    this.accept_terms = accept_terms // eslint-disable-line camelcase
    this.terms_variant = terms_variant // eslint-disable-line camelcase
    this.terms_version = terms_version // eslint-disable-line camelcase
    this.locale = locale
    this.registered = registered
    this.filled_marketing_consent_date = filled_marketing_consent_date // eslint-disable-line camelcase
    this.agreement_with = agreement_with // eslint-disable-line camelcase
    this.user_hashed_id = user_hashed_id // eslint-disable-line camelcase
    this.installed_app = installed_app // eslint-disable-line camelcase
  }
}
